import React from 'react';
import classes from "./CardHeader.module.css";

const CardHeader = ({title,style}) => {
  return (
    <div className={classes.card_header} style={style}>
        <h3 className={classes.title}>
            {title}
        </h3>
    </div>
  )
}

export default CardHeader